import React, { Fragment } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import Logo from '../../images/Logo/logo-white.png';
import MailForm from './Mail/MailForm';
import GroupManager from './Mail/GroupManager';
import ScheduledMail from './Mail/ScheduledMail';
import AdminSocialPage from './adminSocial';
import AdminProductPage from './adminProduct';
import './style.scss';

const NAV = [
    {
        section: '📬 Email',
        items: [
            { key: 'mail',      icon: '📧', label: 'Send Email' },
            { key: 'scheduled', icon: '🕐', label: 'Scheduled Emails' },
            { key: 'groups',    icon: '👥', label: 'Email Groups' },
        ],
    },
    {
        section: '⚙️ Settings',
        items: [
            { key: 'socials',  icon: '🔗', label: 'Social Links' },
            { key: 'products', icon: '🧪', label: 'Products' },
        ],
    },
];

const ALL_TABS = NAV.flatMap(g => g.items);

const AdminPanel = () => {
    const [searchParams, setSearchParams] = useSearchParams();
    const active = searchParams.get('tab') || 'mail';
    const [sidebarOpen, setSidebarOpen] = React.useState(false);
    const navigate = useNavigate();

    const setActive = (key) => setSearchParams({ tab: key });

    const handleLogout = () => {
        localStorage.removeItem('token');
        localStorage.removeItem('isAdmin');
        navigate('/login');
    };

    const renderContent = () => {
        switch (active) {
            case 'mail':      return <MailForm />;
            case 'scheduled': return <ScheduledMail />;
            case 'groups':    return <GroupManager />;
            case 'socials':   return <AdminSocialPage />;
            case 'products':  return <AdminProductPage />;
            default:          return null;
        }
    };

    const activeTab = ALL_TABS.find(t => t.key === active);

    return (
        <Fragment>
            <Helmet><title>Admin Panel — Deep Prabha</title></Helmet>

            <div className={`dp-admin${sidebarOpen ? ' dp-admin--open' : ''}`}>

                {/* ── SIDEBAR ── */}
                <aside className="dp-admin__sidebar">
                    <div className="dp-admin__sidebar-header">
                        <img src={Logo} alt="Deep Prabha" className="dp-admin__logo" />
                        <button className="dp-admin__sidebar-close" onClick={() => setSidebarOpen(false)}>✕</button>
                    </div>

                    <nav className="dp-admin__nav">
                        {NAV.map(group => (
                            <div key={group.section} className="dp-admin__nav-group">
                                <div className="dp-admin__sidebar-label">{group.section}</div>
                                {group.items.map(tab => (
                                    <button
                                        key={tab.key}
                                        className={`dp-admin__nav-item${active === tab.key ? ' dp-admin__nav-item--active' : ''}`}
                                        onClick={() => { setActive(tab.key); setSidebarOpen(false); }}
                                    >
                                        <span className="dp-admin__nav-icon">{tab.icon}</span>
                                        <span className="dp-admin__nav-label">{tab.label}</span>
                                        {active === tab.key && <span className="dp-admin__nav-dot" />}
                                    </button>
                                ))}
                            </div>
                        ))}
                    </nav>

                    <div className="dp-admin__sidebar-footer">
                        <button className="dp-admin__logout" onClick={handleLogout}>
                            <span>🚪</span> Logout
                        </button>
                    </div>
                </aside>

                {/* Overlay for mobile */}
                <div className="dp-admin__overlay" onClick={() => setSidebarOpen(false)} />

                {/* ── MAIN ── */}
                <div className="dp-admin__main">

                    {/* Topbar */}
                    <header className="dp-admin__topbar">
                        <button className="dp-admin__menu-btn" onClick={() => setSidebarOpen(true)}>
                            <span /><span /><span />
                        </button>
                        <div className="dp-admin__topbar-title">
                            <span className="dp-admin__topbar-icon">{activeTab?.icon}</span>
                            {activeTab?.label}
                        </div>
                        <div className="dp-admin__topbar-right">
                            <div className="dp-admin__avatar">A</div>
                            <button className="dp-admin__logout-sm" onClick={handleLogout}>Logout</button>
                        </div>
                    </header>

                    {/* Content */}
                    <main className="dp-admin__content">
                        <div className="dp-admin__content-inner">
                            {renderContent()}
                        </div>
                    </main>
                </div>

            </div>
        </Fragment>
    );
};

export default AdminPanel;
